import MonsterGlassButtonLinkNext from './MonsterGlassButtonLinkNext';

import { FaChevronRight } from 'react-icons/fa';

interface Props {
  colorSwap?: boolean;
  fromLabel: string;
  href: string;
  linkLabel: string;
}

export default function GlassMonsterBreadCrumbNext({ colorSwap, fromLabel, href, linkLabel }: Props) {
  return (
    <div className='flex w-full items-center gap-3'>
      <div className='w-fit'>
        <MonsterGlassButtonLinkNext colorSwap={colorSwap} href={href}>
          {linkLabel}
        </MonsterGlassButtonLinkNext>
      </div>
      <FaChevronRight className='h-6 w-6' />
      <p className='font-semibold'>{fromLabel}</p>
    </div>
  );
}
